<template>
    <v-dialog v-model="enabled" 
        :max-width="maxWidth" 
        :persistent="persistent"
    >
        <v-card :min-height="minHeight" outlined class="d-flex flex-column">
            <slot name="title">
                <v-card-title class="headline" :class="titleClass"> {{ title }} </v-card-title>
            </slot>
            <v-divider v-if="!hideDivider"/>
            <slot name="content">
                <slot name="description">
                    <v-card-text>{{ description }}</v-card-text>
                </slot>
                <v-spacer />
                <slot name="actions">
                    <v-card-actions>
                    <v-spacer />
                        <v-btn :class="classYesButton" outlined @click="choiseYes"> 
                            <v-icon left>{{ iconYesButton }}</v-icon>
                            {{ textYesButton }} 
                        </v-btn>
                        <v-btn outlined @click="choiseCancel"> {{ textCancelButton }} </v-btn>
                    </v-card-actions>
                </slot>
            </slot>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    name: 'PopupConfirmation',
    props:{
            title: {
                type: String,
                default: 'title?'
            },
            description: {
                type: String,
                default: ''
            },
            action: {
                type: Function,
                default: ()=>{}
            },
            actionArgs: {
                type: [Array, Object],
                default: () => {[]}
            },
            textYesButton: {
                type: String,
                default: 'yes'
            },
            iconYesButton: {
                type: String,
                default: 'mdi-send'
            },
            classYesButton: {
                type: String,
                default: 'primary'
            },
            textCancelButton: {
                type: String,
                default: 'cancel'
            },
            maxWidth: {
                type: String,
                default: '70rem'
            },
            minHeight: {
                type: String,
                default: '20rem'
            },
            persistent: {
                type: Boolean,
                default: false
            },
            titleClass: {
                type: String,
                default: ''
            },
            hideDivider: {
                type: Boolean,
                default: false
            }
    },
    data() {
        return {
            enabled: false
        }
    },
    methods: {
        open(){
            this.enabled = true;
        },
        close(){
            this.enabled = false;
        },
        choiseYes(){
            this.close();
            this.action(this.actionArgs);
        },
        choiseCancel(){
            this.close();
        },
    }
}
</script>